import React from "react";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import Store from "@material-ui/icons/Store";
import Warning from "@material-ui/icons/Warning";
import DateRange from "@material-ui/icons/DateRange";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Update from "@material-ui/icons/Update";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import AccessTime from "@material-ui/icons/AccessTime";
import Accessibility from "@material-ui/icons/Accessibility";
import BugReport from "@material-ui/icons/BugReport";
import Code from "@material-ui/icons/Code";
import Cloud from "@material-ui/icons/Cloud";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Tasks from "components/Tasks/Tasks.js";
import CustomTabs from "components/CustomTabs/CustomTabs.js";
import Danger from "components/Typography/Danger.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

import { bugs, website, server } from "variables/general.js";

import {
  dailySalesChart,
  emailsSubscriptionChart,
  completedTasksChart,
} from "variables/charts.js";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);

export default function Dashboard() {
  const classes = useStyles();
  return (
    <div>

      <GridContainer>
  
        <GridItem xs={12} sm={12} md={12}>
        <Card>
  <CardHeader color="info">
    <h4 className={classes.cardTitleWhite}>Client Information</h4>
    <p className={classes.cardCategoryWhite}>
      Detailed client records and relationship info
    </p>
  </CardHeader>
  <CardBody>
    <Table
      tableHeaderColor="info"
      tableHead={[
        "Client Name / Business Name",
        "PAN / GST Number",
        "Contact Person",
        "Contact Number",
        "Email Address",
        "Address",
        "Type of Client",
        "Services Availed Date",
        "Relationship Manager / Assigned Staff",
        "Payment Terms"
      ]}
      tableData={[
        [
          "ABC Traders Pvt Ltd",
          "ABCDE1234F / 27ABCDE1234F1Z5",
          "Sunita Verma",
          "+91 9123456789",
          "sunita.verma@abctraders.com",
          "123 Business Street, Mumbai",
          "Business",
          "2024-11-15",
          "Rajesh Kumar",
          "30 days credit"
        ]
      ]}
    />
  </CardBody>
</Card>


</GridItem>

      </GridContainer>
    </div>
  );
}
